import { WhereaboutsModal, WhereaboutsModalProps } from "shared/components";
import { Flex } from "styled-system/jsx";
import { PropsWithChildren, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Input, Text } from "@ttc3k/trekker";

interface ConfirmInputModalProps
  extends WhereaboutsModalProps,
    PropsWithChildren {
  textToConfirm: string;
}

export const ConfirmInputModal = ({
  isOpen,
  onClose,
  title,
  HeaderIcon,
  cancelButtonProps,
  saveButtonCopy,
  saveButtonProps,
  textToConfirm,
  children,
}: ConfirmInputModalProps) => {
  const { t } = useTranslation();
  const [confirmText, setConfirmText] = useState("");

  useEffect(() => {
    if (saveButtonProps.onClick) {
      setConfirmText("");
    }
  }, [saveButtonProps]);

  return (
    <WhereaboutsModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      HeaderIcon={HeaderIcon}
      cancelButtonProps={cancelButtonProps}
      saveButtonCopy={saveButtonCopy}
      saveButtonProps={{
        ...saveButtonProps,
        disabled: saveButtonProps.disabled || confirmText !== textToConfirm,
      }}
    >
      <Flex flexDir={"column"} gap={"250"}>
        {children}
        <Flex flexDir={"column"} gap={"100"}>
          <Text visual={"bodySemiBold"}>
            {t("core:CONFIRMATION_MODAL.TITLE")}
          </Text>
          <Text color={"text.mid"}>
            {t("core:CONFIRMATION_MODAL.DESCRIPTION", {
              field: t(
                "directory:OPERATOR.PROFILE.KEY_INFO.BUSINESS_NAME",
              ).toLowerCase(),
            })}
          </Text>
        </Flex>
        <Input
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          placeholder={textToConfirm}
        />
      </Flex>
    </WhereaboutsModal>
  );
};
